import { isFullFormValid, isDateGreaterThanYearMinusTwoDays, isDateGreaterThanMonthMinusTwoDays } from "../../util/Validators";
import { validateInput } from './DonationValidationService';
import _ from "lodash";


export const donationNoLoginFormValidationInitialState = {
    donationLineItems: [],

    donorEmailAddressError: false,
    firstNameError: false,
    lastNameError: false,
    addressError: false,
    cityError: false,
    stateError: false,
    zipError: false,
    mobilePhoneNumberError: false,
    countryError: false,
    currentDonationCauseError: false,
    currentDonationCauseValueError: false,
    selectedSponsorshipsError: false,


    donorEmailAddressErrMsg: "",
    firstNameErrMsg: "",
    lastNameErrMsg: "",
    addressErrMsg: "",
    cityErrMsg: "",
    stateErrMsg: "",
    zipErrMsg: "",
    mobilePhoneNumberErrMsg: "",
    countryErrMsg: "",
    currentDonationCauseErrMsg: "",
    currentDonationCauseValueErrMsg: "",
    selectedSponsorshipsErrMsg: "",


    isFormValid: false
}


export const DonationNoLoginFormValidationReducer = (reactState, action) => {
    if (!action.payload) {
        return reactState;
    }
    let isValid = false;
    let donationItems = []
    switch (action.type) {
        case "UPDATE_DONATIONITEMS_VALIDATION_ERR_MSGS":
            let { donationCauses } = action.payload;
            for (let i = 0; i < donationCauses.length; i++) {
                donationItems[i] = {
                    donationLineItemError: false,
                    donationLineItemErrMsg: ""
                };
            }
            return {
                ...reactState,
                donationLineItems: donationItems
            }
        case "ARRAY_VALIDATE_DONATIONLINEITEMS":
            let { idx, donationLineItems } = action.payload;
            let donationLineItemsValidationState = validateInput('donationLineItems', donationLineItems);
            isValid = !donationLineItemsValidationState.hasError;
            let msg = donationLineItemsValidationState.error;
            donationItems = reactState.donationLineItems;
            if (!isValid) {
                donationItems[idx] = {
                    donationLineItemError: true,
                    donationLineItemErrMsg: msg
                };
            } else {
                donationItems[idx] = {
                    donationLineItemError: false,
                    donationLineItemErrMsg: ""
                };
            }
            return {
                ...reactState,
                donationLineItems: donationItems,
                isFormValid: isFullFormValid(reactState, 'donationLineItemsError', !isValid, idx)
            }
        case "VALIDATE_DONOREMAILADDRESS":
            let { donorEmailAddress } = action.payload;
            let emailValidationState = validateInput('donorEmailAddress', donorEmailAddress);
            isValid = !emailValidationState.hasError;
            let donorEmailAddressErrMsg = emailValidationState.error;
            return {
                ...reactState,
                ...({ donorEmailAddressError: !isValid, donorEmailAddressErrMsg: donorEmailAddressErrMsg, isFormValid: isFullFormValid(reactState, 'donorEmailAddressError', !isValid) })
            };
        case "VALIDATE_FIRSTNAME":
            let { firstName } = action.payload;
            let firstNameValidationState = validateInput('firstName', firstName);
            isValid = !firstNameValidationState.hasError;
            let firstNameErrMsg = firstNameValidationState.error;
            return {
                ...reactState,
                ...({ firstNameError: !isValid, firstNameErrMsg: firstNameErrMsg, isFormValid: isFullFormValid(reactState, 'firstNameError', !isValid) })
            };
        case "VALIDATE_LASTNAME":
            let { lastName } = action.payload;
            let lastNameValidationState = validateInput('lastName', lastName);
            isValid = !lastNameValidationState.hasError;
            let lastNameErrMsg = lastNameValidationState.error;
            return {
                ...reactState,
                ...({ lastNameError: !isValid, lastNameErrMsg: lastNameErrMsg, isFormValid: isFullFormValid(reactState, 'lastNameError', !isValid) })
            };
        case "VALIDATE_ADDRESS":
            let { address } = action.payload;
            let addressValidationState = validateInput('address', address);
            isValid = !addressValidationState.hasError;
            let addressErrMsg = addressValidationState.error;
            return {
                ...reactState,
                ...({ addressError: !isValid, addressErrMsg: addressErrMsg, isFormValid: isFullFormValid(reactState, 'addressError', !isValid) })
            };
        case "VALIDATE_CITY":
            let { city } = action.payload;
            let cityValidationState = validateInput('city', city);
            isValid = !cityValidationState.hasError;
            let cityErrMsg = cityValidationState.error;
            return {
                ...reactState,
                ...({ cityError: !isValid, cityErrMsg: cityErrMsg, isFormValid: isFullFormValid(reactState, 'cityError', !isValid) })
            };
        case "VALIDATE_STATE":
            let { state } = action.payload;
            let stateValidationState = validateInput('state', state);
            isValid = !stateValidationState.hasError;
            let stateErrMsg = stateValidationState.error;
            return {
                ...reactState,
                ...({ stateError: !isValid, stateErrMsg: stateErrMsg, isFormValid: isFullFormValid(reactState, 'stateError', !isValid) })
            };
        case "VALIDATE_COUNTRY":
            let { country } = action.payload;
            let countryValidationState = validateInput('country', country);
            isValid = !countryValidationState.hasError;
            let countryErrMsg = countryValidationState.error;
            return {
                ...reactState,
                ...({ countryError: !isValid, countryErrMsg: countryErrMsg, isFormValid: isFullFormValid(reactState, 'countryError', !isValid) })
            };
        case "VALIDATE_ZIP":
            let { zip } = action.payload;
            let zipValidationState = validateInput('zip', zip);
            isValid = !zipValidationState.hasError;
            let zipErrMsg = zipValidationState.error;
            return {
                ...reactState,
                ...({ zipError: !isValid, zipErrMsg: zipErrMsg, isFormValid: isFullFormValid(reactState, 'zipError', !isValid) })
            };
        case "VALIDATE_MOBILEPHONENUMBER":
            let { mobilePhoneNumber } = action.payload;
            let mobilePhoneNumberValidationState = validateInput('mobilePhoneNumber', mobilePhoneNumber);
            isValid = !mobilePhoneNumberValidationState.hasError;
            let mobilePhoneNumberErrMsg = mobilePhoneNumberValidationState.error;
            return {
                ...reactState,
                ...({ mobilePhoneNumberError: !isValid, mobilePhoneNumberErrMsg: mobilePhoneNumberErrMsg, isFormValid: isFullFormValid(reactState, 'mobilePhoneNumberError', !isValid) })
            };
        case "VALIDATE_CURRENTDONATIONCAUSE":
            let { currentDonationCause } = action.payload;
            let currentDonationCauseValidationState = validateInput("currentDonationCause", currentDonationCause);
            isValid = !currentDonationCauseValidationState.hasError
            let currentDonationCauseErrMsg = currentDonationCauseValidationState.error;
            return {
                ...reactState,
                ...({ currentDonationCauseError: !isValid, currentDonationCauseErrMsg: currentDonationCauseErrMsg, isFullFormValid: isFullFormValid(reactState, 'currentDonationCauseError', !isValid) })
            };
        case "VALIDATE_CURRENTDONATIONCAUSEVALUE":
            let { currentDonationCauseValue } = action.payload;
            let currentDonationCauseValueValidationState = validateInput("currentDonationCauseValue", currentDonationCauseValue);
            isValid = !currentDonationCauseValueValidationState.hasError
            let currentDonationCauseValueErrMsg = currentDonationCauseValueValidationState.error;
            return {
                ...reactState,
                ...({
                    currentDonationCauseValueError: !isValid, currentDonationCauseValueErrMsg: currentDonationCauseValueErrMsg,
                    isFullFormValid: isFullFormValid(reactState, 'currentDonationCauseValueError', !isValid)
                })
            };

        case "VALIDATE_SPONSORSHIPS":
            let { sponsorships, selectedSponsorships } = action.payload;
            isValid = true;
            let selectedSponsorshipsErrMsg = "";
            if (!_.isEmpty(sponsorships) && _.isEmpty(selectedSponsorships)) {
                isValid = false;
                selectedSponsorshipsErrMsg = "The selected donation cause requires a sponsorship to be selected"
            }
            return {
                ...reactState,
                ...({
                    selectedSponsorshipsError: !isValid, selectedSponsorshipsErrMsg: selectedSponsorshipsErrMsg,
                    isFullFormValid: isFullFormValid(reactState, 'selectedSponsorshipsError', !isValid)
                })
            };

        case "VALIDATE_SPONSORSHIP_ENDDATE":
            let { sponsorship, name, value } = action.payload;
            let endDataValidationState = validateInput("endDate", value);
            //formValidityData.sponsorshipError[sponsorship.id]?.endDateError}
            let endDateError = endDataValidationState.hasError;
            let endDateErrMsg = endDataValidationState.error;
            if (!endDateError) {
                if (sponsorship.frequency == 'MONTHLY' && !isDateGreaterThanMonthMinusTwoDays(value)) {
                    endDateError = true;
                    endDateErrMsg = "End date must be greater than atleast one month for month frequency";
                }
                if (sponsorship.frequency == 'ANNUALLY' && !isDateGreaterThanYearMinusTwoDays(value)) {
                    endDateError = true;
                    endDateErrMsg = "End date must be greater than atleast one year for anual frequency";
                }
            }
            isValid = !endDateError;
            let newState = {
                ...reactState,
                ['endDateError' + sponsorship.id]: endDateError,
                ['endDateErrMsg' + sponsorship.id]: endDateErrMsg,
                ...{ isFullFormValid: isFullFormValid(reactState, 'endDateError', !isValid) }
            }
            return newState;

        default:
            return reactState
    }
}



